import type { Store } from "@afas-doe-maar/models";
import { useEffect, useState } from "react";
import { suspend } from "suspend-react";

export function useStore<T extends Record<string, any>>(store: Store<T> | null, keys: any[]) {
  const initialData = suspend(async () => store?.get() ?? null, keys);
  const [data, setData] = useState<T | null>(initialData);

  useEffect(() => {
    if (!store) {
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect
      return setData(null);
    }

    return store.subscribe((data) => {
      setData(data);
    });
  }, [store]);

  return data;
}
